import { Group, Text } from '@mantine/core'
import { RowUnit } from './Caption'
import { DATA_FZ, TILE_TEXT } from './railStyle'

// The two cell primitives shared by every weather row on a TILE band — the
// per-day band inside a WeekCard and the current-conditions card under the
// map. They live here rather than in either component because both use them
// and neither owns them; a row that reads one way in "now" and another way in
// "today" is the drift this whole pass was about.

// The left cell of a row — what _week.jsx's ArrowLabel puts there for
// Tides/Sun/Moon, minus the arrow, since a weather reading isn't a directional
// event the way a rising tide or a setting sun is.
export function RowLabel({ children }) {
  return (
    <Text fz={DATA_FZ.value} fw={600} style={{ color: TILE_TEXT.primary }}>
      {children}
    </Text>
  )
}

// A reading plus the word naming it ("71° water", "20% thunder"). Carries the
// second reading in a paired row, where the row label names only the first.
// `value` is the plain-string case; pass `children` when the reading needs
// internal structure, as the seas cell does.
export function Stat({ value, label, children }) {
  return (
    <Group gap={4} align="baseline" wrap="nowrap">
      {children ?? (
        <Text fz={DATA_FZ.value} fw={700} style={{ color: TILE_TEXT.primary }}>
          {value}
        </Text>
      )}
      <RowUnit>{label}</RowUnit>
    </Group>
  )
}
